import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ClampLines from 'react-clamp-lines';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LoadingSpinner from 'components/LoadingSpinner';
import Label from 'components/shared/Label/Label';
import { Message } from 'components/shared';

const useStyles = makeStyles(theme => {
  const { palette } = theme;

  return {
    root: {
      padding: '.5rem'
    },
    note: {
      marginBottom: '.25rem'
    },
    noteHeader: {
      display: 'flex',
      alignItems: 'center',
      color: palette.grey.darker
    },
    noteTitle: {
      marginLeft: '.5rem',
      display: 'inline-block'
    },
    noteBody: {
      padding: '.25rem .5rem',
      fontSize: '.825rem',
      color: palette.grey.dark,
      borderLeft: `2px solid ${palette.grey.medium}`
    },
    viewAll: {
      fontWeight: theme.typography.fontWeightBold,
      color: palette.primary.main,
      textTransform: 'uppercase',
      marginTop: '1rem',
      cursor: 'pointer'
    }
  };
});

const NotesAccess = ({ state, forwardRef, setTableExportData }) => {
  const classes = useStyles();
  const { isLoading, isError, error, data } = state;

  useEffect(() => {
    setTableExportData({
      title: 'Notes Widget',
      columns: [],
      rows: []
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderNotes = () => {
    if (isError) {
      return <Message type="error" text={error} />;
    }

    if (isLoading || !data) {
      return <LoadingSpinner />;
    }

    const { notes } = data;

    return notes.map(note => (
      <Box key={note.researchNoteId} className={classes.note}>
        <Box className={classes.noteHeader}>
          <Label
            themeColor="primary"
            size="small"
            text={moment(note.callDate).format('MM/DD/YYYY')}
          />
          <Box className={classes.noteTitle}>{`${note.noteKind} by ${note.author}`}</Box>
        </Box>
        <Box className={classes.noteBody}>
          <ClampLines text={note.plainTextContent} lines={3} buttons={false} />
        </Box>
      </Box>
    ));
  };

  return (
    <Box ref={forwardRef} className={classes.root} name="notes">
      {renderNotes()}
    </Box>
  );
};

NotesAccess.propTypes = {
  state: PropTypes.shape({
    masterObjectId: PropTypes.number,
    data: PropTypes.shape({
      notes: PropTypes.arrayOf(
        PropTypes.shape({
          researchNoteId: PropTypes.number,
          createdOn: PropTypes.string,
          author: PropTypes.string,
          plainTextContent: PropTypes.string
        })
      )
    }),
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.string
  }),
  forwardRef: PropTypes.shape({}),
  setTableExportData: PropTypes.func
};

NotesAccess.defaultProps = {
  state: {},
  forwardRef: null,
  setTableExportData: null
};

export default NotesAccess;
